import { ChangeDetectorRef, Component, Inject, LOCALE_ID } from '@angular/core';
import { CellClickEvent, PageChangeEvent } from '@progress/kendo-angular-grid';
import { FormBuilder } from '@angular/forms';
import { LoggerService } from '../../services/logger.service';
import { BIGridComponent, BeforeAction } from '../BI-Grid/bi-grid.component';
import { BIModulesService } from '../../bi-modules.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { IGrid } from 'bi-interfaces/lib/interfaces/IGrid';
import { GetValuePipe } from '../../pipes/get-value.pipe';
import { TranslateService } from '@ngx-translate/core';
import { ErrorDetailsService } from '../../services/error-details.service';
import { IntlService } from '@progress/kendo-angular-intl';
import { toODataString } from '@progress/kendo-data-query';
import { DataTypes as DataType } from 'bi-interfaces';
import { Router } from '@angular/router';
import { UiProfileService } from '../../services/ui-profile.service';
import { CreateDialog } from '../bi-dialog/createDialog.service';

enum StatusAction {
  ADD = "Add",
  UPDATE = "Update",
  NOP = "NOP",
  Delete = "Delete"
}
@Component({
  selector: 'BI-ChildGrid',
  templateUrl: './bi-childGrid.component.html',
  styleUrls: ['./bi-childGrid.component.scss']
})

export class BIChildGridComponent extends BIGridComponent implements IGrid {
  selectAll: boolean = false;
  public ForceDiasbleRowIdsCheckBox: number[] = [];

  constructor(
    formBuilder: FormBuilder,
    loggerService: LoggerService,
    biService: BIModulesService,
    messages: MessageService,
    getValuePipe: GetValuePipe,
    cd: ChangeDetectorRef,
    translateService: TranslateService,
    errorDetailsService: ErrorDetailsService,
    @Inject(LOCALE_ID) localeId: any,
    intlService: IntlService,
    router: Router,
    uiProfileService: UiProfileService,
    @Inject('CreateDialog') public _createDialog: CreateDialog,


  ) {
    super(_createDialog,localeId, intlService, formBuilder, loggerService, biService, messages, getValuePipe, translateService, cd, errorDetailsService, router, uiProfileService);
    this.IsHeader=false;
  }
  public override read() {
    if (!this.filter) {
      this.filter = '';
      if (this.DataService.state.sort)
        this.filter += toODataString({ "sort": this.DataService.state.sort });
    }
    if (this.HasPaging) {
      this.DataService.read(`${this.filter ? `$skip=${this.DataService.state.skip}&${this.filter}` : '&$skip=' + this.DataService.state.skip}&$top=${this.DataService.state.take}&$count=true`);
    }
    else {
      this.DataService.read(`${this.filter ? `$skip=${this.DataService.state.skip}&${this.filter}` : '&$skip=' + this.DataService.state.skip}&$count=true`);
    }
  }

  public override AddRow() {
    this.statusAction = StatusAction.ADD;
    // if (this.getFormGroup(this.RowID)?.getRawValue() && !this.GridData.data.data.find((res: any) => res[this.RowIdentifier] == this.RowID)) this.GridData.data.data.unshift(this.getFormGroup(this.RowID)?.getRawValue());
    //this.closeRow(this.rowIndex)
    this.BeforeAddRow.emit(null);
    this.StopAddSubscription?.unsubscribe();
    this.StopAddSubscription = this.AllowAdd?.subscribe(async (res: any) => {
      if (res) {
        if (this.RowID && this.getFormGroup(this.RowID)?.getRawValue() && this.getFormGroup(this.RowID)?.getRawValue()[this.ChangeSet_Status] !== StatusAction.Delete && !this.GridData?.data?.data?.find((res: any) => res[this.RowIdentifier] == this.RowID))
          this.GridData?.data?.data?.unshift(this.getFormGroup(this.RowID)?.getRawValue());
        this.closeRow(this.rowIndex);
        this.OnAddRow.emit(null);
        let formGroup = this.formBuilder.group(this.form);
        this.RowID = this.GetNewRowID();
        formGroup.patchValue({ ...this.DefaultValue, [this.ChangeSet_Status]: StatusAction.ADD, [this.RowIdentifier]: this.RowID });
        this.formGroups.push(formGroup);
        if (this.Mygrid) this.Mygrid?.addRow(this.createFormGroup());
        this.CurrentSelectRow = this.getFormGroup(this.RowID);
        await this.AfterAddRow.emit(null);
      }
    });

  }

  public override async DeleteRow() {

    if (this.getFormGroup(this.RowID)?.getRawValue() && !this.GridData?.data?.data?.find((res: any) => res[this.RowIdentifier] == this.RowID)) {
      this.BeforeDeleteRow.emit();
      this.formGroups.splice(this.formGroups.indexOf(this.getFormGroup(this.RowID)), 1);
      this.closeRow(this.rowIndex);
      this.resetRowIndex = 0;
      this.RowID = this.GridData?.data?.data[0]?.[this.RowIdentifier];// this.formGroups[0].get(this.RowIdentifier)?.getRawValue();
      this.CurrentSelectRow?.reset();
      this.CurrentSelectRow = this.getFormGroup(this.RowID);
    } else if (this.CurrentSelectRow) {
      let index = this.GridData['data']['data']
        .findIndex((res: any) => res[this.RowIdentifier] == this.RowID);
      this.CurrentSelectRow = index != -1 ? this.getFormGroup(this.RowID) : this.getFormGroup(this.GridData['data']['data'][0][this.RowIdentifier]);
      var formgroup = this.CurrentSelectRow;
      if (formgroup) {
        this.BeforeDeleteRow.emit();
        if (formgroup.get(this.ChangeSet_Status)?.value === StatusAction.ADD) {
          // setTimeout(() => {
          let currentLineIndex = this.formGroups.findIndex(e => e.controls[this.RowIdentifier].value == this.RowID);
          this.formGroups.splice(currentLineIndex, 1);
          // });
        } else {
          this.CurrentSelectRow.patchValue({ [this.ChangeSet_Status]: StatusAction.Delete });
        }
      }

      setTimeout(() => {
        if (this.GridData['data']?.['data']?.length) {
          this.GridData['data']['data'].splice(index != -1 ? index : 0, 1);
          if (this.GridData['data']['data']?.length) {
            index = (index >= this.GridData['data']['data']?.length) ? this.GridData['data']['data']?.length - 1 : index;
            this.resetRowIndex = index;
            this.RowID = this.GridData['data']['data'][index != -1 ? index : 0][this.RowIdentifier]
          }
        }
      });
    }
    else {
      this.alertShow("Please select a row to Delete", 1);// test
    }
    await this.RowChange.emit()
  };

  override changeCheckBox(event: any, Name: string, dataItem: any, rowIndex: any) {
    this.CurrentSelectRow = this.getFormGroup(dataItem?.[this.RowIdentifier]);
    if (this.CurrentSelectRow.get(this.ChangeSet_Status)?.getRawValue() !== StatusAction.ADD) {
      this.resetRowIndex = rowIndex;
      this.CurrentSelectRow.get(this.ChangeSet_Status)?.patchValue(StatusAction.UPDATE);
      this.RowChange.emit()
    } else {
      this.RowChange.emit()///
      // why you are changing th stsatus here
      this.CurrentSelectRow.get(this.ChangeSet_Status)?.patchValue(StatusAction.ADD);

    }
    //change in formGroup
    let formGroupconditions: ((res: any) => boolean)[] = [];
    if (this.getTypeFilter(this.DataService.Key) === DataType.Date) {
      formGroupconditions.push((res: any) => this.CompareBetweenTwoDate(res, dataItem));
    } else {
      formGroupconditions.push((res: any) => res.controls[this.DataService.Key].value === dataItem[this.DataService.Key]);
    }
    if (this.DataService.Key2) {
      if (this.getTypeFilter(this.DataService.Key2) === DataType.Date) {
        formGroupconditions.push((res: any) => this.CompareBetweenTwoDate(res, dataItem));
      } else {
        formGroupconditions.push((res: any) => res.controls[this.DataService.Key2].value === dataItem[this.DataService.Key2]);
      }
    }
    if (this.DataService.Key3) {
      if (this.getTypeFilter(this.DataService.Key3) === DataType.Date) {
        formGroupconditions.push((res: any) => this.CompareBetweenTwoDate(res, dataItem));
      } else {
        formGroupconditions.push((res: any) => res.controls[this.DataService.Key3].value === dataItem[this.DataService.Key3]);
      }
    }
    if (this.DataService.Key4) {
      if (this.getTypeFilter(this.DataService.Key4) === DataType.Date) {
        formGroupconditions.push((res: any) => this.CompareBetweenTwoDate(res, dataItem));
      } else {
        formGroupconditions.push((res: any) => res.controls[this.DataService.Key4].value === dataItem[this.DataService.Key4]);
      }
    }
    if (this.DataService.Key5) {
      if (this.getTypeFilter(this.DataService.Key5) === DataType.Date) {
        formGroupconditions.push((res: any) => this.CompareBetweenTwoDate(res, dataItem));
      } else {
        formGroupconditions.push((res: any) => res.controls[this.DataService.Key5].value === dataItem[this.DataService.Key5]);
      }

    }
    if (this.DataService.Key6) {
      if (this.getTypeFilter(this.DataService.Key6) === DataType.Date) {
        formGroupconditions.push((res: any) => this.CompareBetweenTwoDate(res, dataItem));
      } else {
        formGroupconditions.push((res: any) => res.controls[this.DataService.Key6].value === dataItem[this.DataService.Key6]);
      }

    }
    let formGroupindex = this.formGroups.findIndex((res: any) => formGroupconditions.every(condition => condition(res)));
    this.formGroups[formGroupindex].get(Name)?.patchValue(event.target.checked);

    //change id data
    //let index = this.GridData['data']['data'].findIndex((res: any) => res[this.RowIdentifier] == this.CurrentSelectRow.get(this.RowIdentifier)?.getRawValue());
    let conditions: ((res: any) => boolean)[] = [];
    conditions.push((res: any) => res[this.DataService.Key] === dataItem[this.DataService.Key]);
    if (this.DataService.Key2) {
      conditions.push((res: any) => res[this.DataService.Key2] === dataItem[this.DataService.Key2]);
    }
    if (this.DataService.Key3) {
      conditions.push((res: any) => res[this.DataService.Key3] === dataItem[this.DataService.Key3]);
    }
    if (this.DataService.Key4) {
      conditions.push((res: any) => res[this.DataService.Key4] === dataItem[this.DataService.Key4]);
    }
    if (this.DataService.Key5) {
      conditions.push((res: any) => res[this.DataService.Key5] === dataItem[this.DataService.Key5]);
    }
    if (this.DataService.Key6) {
      conditions.push((res: any) => res[this.DataService.Key6] === dataItem[this.DataService.Key6]);
    }
    let index = this.GridData['data']['data'].findIndex((res: any) => conditions.every(condition => condition(res)));
    this.GridData['data']['data'][index][Name] = event.target.checked;
  }

  public override async cellClickHandler(args: CellClickEvent) {
    // if (this.CurrentSelectRow.valid) {
    if (this.CurrentSelectRow.status !== 'INVALID') {
      await this.closeRow();
      if (this.RowID && this.GridData?.data?.data && !this.GridData?.data?.data?.find((res: any) => res[this.RowIdentifier] == this.RowID)
        && this.getFormGroup(this.RowID)?.getRawValue()[this.ChangeSet_Status] === StatusAction.ADD) {
        setTimeout(() => {
          this.GridData?.data?.data?.unshift(this.getFormGroup(this.RowID)?.getRawValue());
        });
        args.dataItem = this.getFormGroup(this.RowID)?.getRawValue()
        args.rowIndex = 0;
      }
      await this.insertDataItemInRow(args);
      if (this.prevRow != args.rowIndex) {
        // this.CurrentSelectRow = this.getFormGroup(this.RowID);
        this.RowChange.emit(args);
      }
      this.RowChangeMasterGridChangeDetails.emit()
    }

  }
  public override async Save() {
    this.StopSaveSubscription?.unsubscribe();
    this.StopSaveSubscription = this.AllowSave?.subscribe((res: any) => {
      if (res) {
        super.saveAll();
      }
    });
    let ret = await this.BeforeActionSave();
    if (ret === BeforeAction.NoSaveImp) {
      this.AllowSave.next(true);
    }
  }
  public override Cancel() {
    this.resetRowIndex = 0;
    this.RowID = '';
    this.read();
    this.closeRow()
    this.ResetRowUpdateStatus();
  }
  override  ConvertBoolean2Number(): void {
    let boolean = this.Columns.filter(x => x.IsNumber2Boolean == true).map(x => x.Name);
    if (boolean[0]) {
      let modfiedCol = this.formGroups.filter(c => (c.controls[this.ChangeSet_Status]['value'] == 'Add' && c.status == "VALID")
        || (c.controls[this.ChangeSet_Status]['value'] == 'Update')
      );
      if (modfiedCol && modfiedCol[0]) {
        modfiedCol.map((FG) => {

          boolean.forEach((column) => {
            FG.controls[column].patchValue(
              +FG?.get(column)?.getRawValue())
          });
        }
        )
      }
    }
  }
  IsDisabledCellTemplate(RowID: string, controlName: string): boolean {
    return this.getFormGroup(RowID)?.controls[controlName]?.disabled

  }

  public override onPageChange(e: PageChangeEvent): void {
    this.changePage(e);    
}
}
